import { render } from "./JFrecall.vue?vue&type=template&id=ecda6eb8&scoped=true"
import script from "./JFrecall.vue?vue&type=script&lang=js"
export * from "./JFrecall.vue?vue&type=script&lang=js"

import "./JFrecall.vue?vue&type=style&index=0&id=ecda6eb8&lang=scss&scoped=true"
import "./JFrecall.vue?vue&type=style&index=1&id=ecda6eb8&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecda6eb8"]])

export default __exports__